import { ConsentId } from '@/shared/enums';
import { AssetLoader } from '@/shared/utils';
import Captcha from './captcha';

export default async ({ $deferredLoader, $oneTrust, $services }, inject) => {
  const info = $services.resolve('info');

  await info.fetch();
  const captchaKey = info.googleReCaptchaV3PublicKey;

  const captcha = new Captcha(captchaKey);
  inject('captchaV3', captcha);

  if (!captchaKey) {
    return;
  }

  Promise.all([
    $deferredLoader.appReady.promise,
    $deferredLoader.oneTrust.promise,
  ])
    .then(() => {
      if (!$oneTrust.areConsentsAccepted([ConsentId.CAPTCHA, ConsentId.STRICTLY_NECESSARY])) {
        return Promise.reject();
      }

      return new AssetLoader().load([
        { id: 'captcha', src: `//www.google.com/recaptcha/api.js?render=${captchaKey}` },
      ]);
    })
    .catch(() => {});
};
